import { useCallback, useMemo } from 'react';
import { usePlatformsContext } from './use-platforms';
import { buildPlatformRedirectUrl } from '@/lib/utils';
import { TokensHolder } from '@/lib/services';

export const useRedirectUser = () => {
	const { platforms } = usePlatformsContext();
	const platform = useMemo(() => platforms[0], [platforms]);

	const redirectUser = useCallback(
		(tokensHolder?: TokensHolder, deviceKey?: string) => {
			if (!platform?.signOnUrl) {
				throw new Error('platform?.signOnUrl is undefined.');
			}

			window.location.href = buildPlatformRedirectUrl({ signOnUrl: platform.signOnUrl, tokensHolder, deviceKey });
		},
		[platform]
	);

	return redirectUser;
};
